<template>
  <div class="popup">
    <!--弹窗与蒙层-->
    <div class="newrank-code-content" v-show="codeShow">
      <div class="newrank-code-box">
        <p class="newrank-code-title">{{codeTitle}}</p>
        <div class="code-line">
          <div class="circle circle-left"></div>
          <div class="dashed-line"></div>
          <div class="circle circle-right"></div>
        </div>
        <div class="newrank-code">
          <img :src="headImg(codeImg,'code')" alt="">
        </div>
        <p>{{tips}}</p>
      </div>
      <div class="newrank-code-close" @click="closePop()">×</div>
    </div>
    <div class="mask" v-show="codeShow"></div>
  </div>
</template>

<script>
  import nr from 'nr'
  const common = nr.loadScript('common')

  export default {
    name: 'Popup',
    props: {
      value: {
        type: Boolean,
        default: true
      },
      codeTitle: {
        type: String,
        default: ''
      },
      codeImg: {
        type: String,
        default: ''
      },
    },

    data () {
      return {
        codeShow:false,
        tips: '长按识别二维码关注'
      }
    },

    mounted(){
      this.codeShow = this.value;
    },
    watch:{
      value(newVal, oldVal){
        this.codeShow = newVal;
      },
      codeShow(val) {
        this.$emit('input',val);
      },

    },

    methods: {
      headImg(str,type){
        if(str == 'baika'){
          this.tips = '长按识别小程序码进入'
          return require('../../assets/img/about/baika.png')
        }else if(str == 'liangzi'){
          this.tips = '长按识别小程序码进入'
          return require('../../assets/img/about/liangzi.png')
        }else{
          this.tips = '长按识别二维码关注'
          return common.createBgUrl(str,type)
        }
      },
      closePop(){
        this.codeShow = false;
      },
    }
  }
</script>

<style lang="css" scoped>
  .mask{
    width: 100%;
    height: 100%;
    position: fixed;
    left: 0;
    top: 0;
    background: rgba(0,0,0,.5);
    z-index: 3;
  }
  .newrank-code-content{
    position: fixed;
    top: 100px;
    left: 50%;
    margin-left: -120px;
    z-index: 4;
  }
  .newrank-code-box{
    width:240px;
    height:285px;
    line-height: 30px;
    background:#ffffff;
    border-top: 5px solid #FF7800;
    border-radius:6px;
    text-align: center;
    font-size: 12px;
    overflow: hidden;
    color:#999999;
    box-shadow:0 5px 11px rgba(0,0,0,.45);
  }
  .newrank-code-close{
    width: 30px;
    height: 30px;
    border-radius: 100%;
    border: 1px solid #fff;
    color: #fff;
    display: -webkit-flex;
    justify-content: center;
    align-items: center;
    font-size: 22px;
    font-weight: lighter;
    position: relative;
    left: 50%;
    top: 20px;
    margin-left: -15px;
  }
  .newrank-code-title{
    font-size: 18px;
    color: #333333;
    font-weight: bold;
    margin-top: 18px;
    margin-bottom:10px;
  }
  .newrank-code{
    width: 124px;
    height: 124px;
    background: #ccc;
    margin: 30px auto 10px auto;
  }
  .newrank-code>img{
    width: 100%;
    height: 100%;
  }
  .code-line{
    width: 100%;
    height: 10px;
    display: -webkit-flex;
    display:flex;
    justify-content: space-between;
    align-items: center;
  }
  .circle{
    width: 10px;
    height: 10px;
    border-radius: 100%;
    background: rgba(101,101,101,1);
  }
  .circle-left{
    margin-left: -5px;
  }
  .circle-right{
    margin-right: -5px;
  }
  .dashed-line{
    width: 213px;
    height: 0;
    border: 1px dashed #D4D4D4;
  }

</style>



// WEBPACK FOOTER //
// popup.vue?498be980